import { FC, ReactElement, useState } from "react";
import { Input, InputGroup, InputRightElement, IconButton } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { debounce } from "lodash";

interface SearchInputProps {
    handleSearch: any
}

const SearchInput: FC<SearchInputProps> = ({ handleSearch }): ReactElement => {

    const search = debounce((query) => {
        handleSearch(query);
    }, 800);

    const handleChange = (event: any) => {
        const { value } = event.target;
        search(value);
    };

    return (
        <InputGroup>
            <Input
                placeholder="Pencarian..."
                onChange={handleChange}
            />
            <InputRightElement>
                <IconButton
                    aria-label="Pencarian"
                    icon={<SearchIcon />}
                    variant="ghost"
                />
            </InputRightElement>
        </InputGroup>
    );
}

export default SearchInput;
